import { sanitize } from '../../../utils/strings'
import { FAVORITE_GAME_CATEGORY_SLUG } from '../../App/constants'
import { GAMES_ORDER_ASC, GAMES_ORDER_DESC } from '../../Games/constants'
import { Category, GameWithUserInformation } from '../types'
import { CreateSelectedSlugsProps, OrderByFields, GameOrder, Filters, Filter } from './types'

export function getSelectedGames({
  games,
  filters,
  order,
  orderByFields,
}: CreateSelectedSlugsProps): GameWithUserInformation[] {
  const filteredGames = Object.values(games).filter((game) => evaluateFilters(filters, game))

  const sortedGames = filteredGames.sort(basicSort(order)).sort(fieldsSort(orderByFields))

  return sortedGames
}

function evaluateFilters(filters: Filter[], game: GameWithUserInformation) {
  return filters.every((filter) => evaluate(game)(filter))
}

function evaluate(game: GameWithUserInformation) {
  return ({ compareFn }: Filter) => compareFn(game)
}

const getOrderMultiplier = (game: GameWithUserInformation, orderByFields: OrderByFields) => {
  const orderIndex = orderByFields.findIndex((currentOrder) => game[currentOrder])
  const order = orderIndex > -1 ? orderIndex : orderByFields.length

  return orderByFields.length - order
}

export function getFilters(currentCategory: string, searchInput: string, selectedCategory?: Category): Filters {
  const sanitizedSearchInput = sanitize(searchInput)

  return [
    {
      compareFn: ({ category, isFavorite }) =>
        !currentCategory ||
        (currentCategory === FAVORITE_GAME_CATEGORY_SLUG && isFavorite) ||
        category.some((current) => current === currentCategory),
    },
    {
      compareFn: ({ slug, name, searchIndex }) =>
        searchInput === ''
          ? true
          : sanitize(slug).includes(sanitizedSearchInput) ||
            sanitize(name).includes(sanitizedSearchInput) ||
            sanitize(searchIndex).includes(sanitizedSearchInput),
    },
    {
      compareFn: ({ slug }) => selectedCategory?.games.some((game) => game.slug === slug) || true,
    },
  ]
}

function fieldsSort(orderByFields: OrderByFields) {
  return (next: GameWithUserInformation, previous: GameWithUserInformation) => {
    const nextGameMultiplier = getOrderMultiplier(next, orderByFields)
    const previousGameMultiplier = getOrderMultiplier(previous, orderByFields)

    return nextGameMultiplier <= previousGameMultiplier ? 1 : -1
  }
}

function basicSort(order: GameOrder) {
  return (next: GameWithUserInformation, previous: GameWithUserInformation) => {
    if (order === GAMES_ORDER_ASC || order === GAMES_ORDER_DESC) {
      const orderMulti = order === GAMES_ORDER_ASC ? 1 : -1

      return next.name > previous.name ? 1 * orderMulti : -1 * orderMulti
    }

    return next[order] || 0 > (previous[order] || 0) ? 1 : -1
  }
}
